import { render, staticRenderFns } from "./MyVideos.vue?vue&type=template&id=46a8d7aa"
import script from "./MyVideos.vue?vue&type=script&lang=js"
export * from "./MyVideos.vue?vue&type=script&lang=js"
import style0 from "./MyVideos.vue?vue&type=style&index=0&id=46a8d7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports